import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { defaultProperties } from './default-properties';
import { EventService } from './event.service';
import { ContainerProperties, OverlayProperties } from './interfaces';
import { OverlayContainerComponent } from './overlay-container.component';

@Injectable()
export class Overlay {
  globalEventsSubscription;
  componentRefs: any = {};
  _properties: any = {};
  _defaultProperties: any;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private eventService: EventService
  ) {
    this.globalEventsSubscription = this.eventService.emitter.subscribe((event) => {
      this.handleGlobalEvents(event);
    });
  }

  appendComponentToBody(properties: any, component: any = OverlayContainerComponent): void {
    //if (this.componentRefs[properties.id]){
    if (this.componentRefs[0]) {
      return;
    }

    const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);

    //this.componentRefs[properties.id] = componentRef;
    this.componentRefs[0] = componentRef;

    (<ContainerProperties>componentRef.instance).properties = properties;
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    // Add to body
    document.body.appendChild(domElem);
  }

  /*
    appendComponentToTag(element: any, tagname: string = ''):void {
        if (tagname){
            document.getElementsByTagName(tagname)[0].appendChild(element);
        } else {
            document.body.appendChild(element);
        }
    }
    */

  public load(properties: OverlayProperties): void {
    properties = this.applyPropertieDefaults(defaultProperties, properties);
    this.appendComponentToBody(properties);
  }

  public close(prop: any = {}): void {
    /*
        if (this.componentRefs[prop.id]){
            (<ContainerProperties>this.componentRefs[prop.id].instance).closeOverlay();
        }
        */
  }

  applyPropertieDefaults(defaultProperties: any, properties: any) {
    if (!properties) {
      properties = {};
    }
    if (!properties.index) {
      properties.index = 0;
    }
    this._defaultProperties = Object.assign({}, defaultProperties);
    return Object.assign(this._defaultProperties, properties);
  }

  objectLength(obj: any): number {
    let length = 0,
      key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) length++;
    }
    return length;
  }

  handleGlobalEvents(event: any) {
    if (event.type === '[Overlay] Hide') {
      this.handleCloseEvent();
    }
  }

  handleCloseEvent() {
    //const id = 'popover'; // Note: pass id in event
    if (!this.componentRefs[0]) {
      return;
    }

    this.appRef.detachView(this.componentRefs[0].hostView);
    this.componentRefs[0].destroy();
    delete this.componentRefs[0];
  }
}
